import UnsavedChangesDialog from "./views/UnsavedChangesDialog";

const routes = [
  {
    path: "/unsaved-changes-dialog",
    name: "unsaved-changes-dialog",
    component: UnsavedChangesDialog,
    props: route => ({
      subject: route.query.subject
    })
  }
];

export default routes;
